import { render, staticRenderFns } from "./RoleInfoForm.vue?vue&type=template&id=2baea61d&"
import script from "./RoleInfoForm.vue?vue&type=script&lang=js&"
export * from "./RoleInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./RoleInfoForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports